const BASE_URL = "https://spotevent.sopa.org/api/v1";

export default BASE_URL;
